import { render, staticRenderFns } from "./CustomerChatComponent.vue?vue&type=template&id=de665840&scoped=true&"
import script from "./CustomerChatComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerChatComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomerChatComponent.vue?vue&type=style&index=0&id=de665840&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de665840",
  null
  
)

export default component.exports